import React from 'react';
import { Stack } from '@mui/material';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';
import { IEvent } from '../../types/global/helper';
import { HelpOutline } from '@mui/icons-material';
import { TextWithIcon } from '../TextWithIcon/TextWithIcon';
import FAQItem from '../Collapsible/Collapsible';

export interface IEventDetails {
    event: IEvent;
}

const EventFAQ: React.FC<IEventDetails> = ({ event }) => {
    const { themeStyle } = useThemeContext();
    return (
        <Stack>
            <Stack mt={2} mb={4}>
                <TextWithIcon
                    icon={
                        <HelpOutline
                            sx={{
                                color: theme[themeStyle].tag_white,
                            }}
                            height={'20px'}
                            width={'20px'}
                        />
                    }
                    text="FAQ"
                />
                {event &&
                    event.faq &&
                    event.faq?.map((q, i) => <FAQItem key={i} question={q.question} answer={q.answer} />)}
            </Stack>
        </Stack>
    );
};

export { EventFAQ };
